export const FooterElementID = "footer-container";
export const HeaderBottomContainerElementID = "header-bottom-container";
export const AfterPageLayoutContainerElementID = "after-page-layout-container";
